import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// ui
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './element-variables.scss'
// rem px切换
import '@/utils/rem.js'
// 跑马灯无线轮播
import seamlessScroll from 'vue-seamless-scroll'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(seamlessScroll)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
